import React from "react";
import OutcomeImg1 from "../../assets/images/outcomeIcon1.svg";
import OutcomeImg2 from "../../assets/images/outcomeIcon2.svg";
import OutcomeImg3 from "../../assets/images/outcomeIcon3.svg";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { OutcomeData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";

import styles from "./Outcomes.module.css";

export default function Outcome() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_PUBLISHING_OUTCOMES2
  );
  const apiData = response?.publishingOutcome2 ?? OutcomeData;
  const navigate = useNavigate();
  const outcomeImages = [OutcomeImg1, OutcomeImg2, OutcomeImg3];

  return (
    <section className={styles.outcomes}>
      <div className={styles.container}>
        <h3>
          Publishing <span>& Outcomes</span>
        </h3>
        <h5>
          Track and showcase the impact of our Knowledge Series across various
          publication formats and academic outputs.
        </h5>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((i, index) => (
              <article className={styles.card} key={i.id}>
                <figure>
                  <img src={outcomeImages[index]} alt={i.number} />
                </figure>
                <div className={styles.content}>
                  <h4>
                    {i.number} <span>{i.number_text}</span>
                  </h4>
                  <p>{i.title}</p>
                  <p className={styles.time}>{i.text}</p>
                </div>
              </article>
            ))
          )}
        </div>
        <button onClick={() => navigate("/")} className={styles.button}>
          See All Outputs
        </button>
      </div>
    </section>
  );
}
